module.exports = __webpack_public_path__ + "static/media/icons-ic-sms-outgoing.d23e4e20.svg";